import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import {
    getDeviceType,
    getVersion,
    serviceErrorToAnalyticsFormat,
} from 'yoda-account-components/lib/analytics/DigitalAnalyticsHelper';

export class SavedListActionFilter extends BaseActionFilter {
    getPageLoadAttributes(store, data) {
        const { context } = store.getState();
        const deviceType = getDeviceType(context);
        const attributes = this.updateCommonDigitalData();
        attributes.page.pageInfo.pageName = data.pageName.toLowerCase(); // need to set
        attributes.page.pageInfo.pageType = 'my lists';
        attributes.page.pageInfo.siteSection = 'account';
        attributes.page.pageInfo.deviceType = deviceType;
        attributes.page.pageInfo.searchRedirect = ''; // need to set this
        attributes.page.pageInfo.releaseVersion = context.__RELEASEVERSION__;
        attributes.page.pageInfo.version = getVersion('yoda account');
        attributes.page.category = {};
        attributes.page.category.primaryCategory = 'account';
        attributes.page.category.subCategory1 = '';
        attributes.page.category.subCategory2 = '';
        attributes.page.category.department = 'account';
        attributes.error = serviceErrorToAnalyticsFormat({}); // set empty error
        return attributes;
    }
}

export default SavedListActionFilter;
